import React from "react";
import {
  translationConstants,
  Directions,
  TableColumnStyle,
  modeConstants,
  genderEnum,
  sportConstants,
  boatTypeEnum,
} from "../../../../constants";
import { copyToClipboard } from "../../../../system";
import Tooltip from "@mui/material/Tooltip";
import {
  TableDeleteIcon,
  TableEditIcon,
  TableViewIcon,
} from "../../../../assets/images/icon/iconsProvider";

export const getcolumns = (
  t,
  direction,
  setModalMode,
  getRowData,
  onDelete
) => [
  {
    id: "id",
    accessor: "id",
    name: t(translationConstants.RECORD_ID),
    cell: (row) => (
      <Tooltip
        title={<div>{t(translationConstants.COPY_TO_CLIPBOARD)}</div>}
        placement="top"
        arrow
      >
        <div
          className="truncate-text cursor-pointer"
          onClick={() => copyToClipboard(row.id)}
        >
          {row.id}
        </div>
      </Tooltip>
    ),
    reorder: true,
    sortable: true,
    sortDirection: null,
    minWidth: TableColumnStyle.COLUMN_WIDTH_120,
    maxWidth: TableColumnStyle.COLUMN_WIDTH_120,
  },
  {
    id: "name",
    reorder: true,
    sortable: true,
    sortDirection: null,
    accessor: "name",
    name: t(translationConstants.BOAT_CLASS),
    selector: (row) =>
      direction === Directions.rtl && row.arabicName
        ? row.arabicName
        : row.name,
    // minWidth: TableColumnStyle.COLUMN_WIDTH_180,
  },
  {
    id: "boatTypeId",
    reorder: true,
    sortable: true,
    sortDirection: null,
    accessor: "boatTypeId",
    name: t(translationConstants.BOAT_TYPE),
    selector: (row) => {
      return getBoatTypeTranslation(t, row.boatTypeId);
    },
    // minWidth: TableColumnStyle.COLUMN_WIDTH_180,
  },
  {
    id: "sportId",
    reorder: true,
    sortable: true,
    sortDirection: null,
    accessor: "sportId",
    name: t(translationConstants.SPORT),
    selector: (row) => {
      return getSportTranslation(t, row.sportId);
    },
    // minWidth: TableColumnStyle.COLUMN_WIDTH_140,
    // maxWidth: TableColumnStyle.COLUMN_WIDTH_140,
  },
  {
    id: "genders",
    reorder: true,
    sortable: true,
    sortDirection: null,
    accessor: "genders",
    name: t(translationConstants.gender),
    selector: (row) => {
      return getTranslatedGenders(t, row.genders);
    },
    // minWidth: TableColumnStyle.COLUMN_WIDTH_180,
  },
  {
    id: "description",
    reorder: true,
    sortable: true,
    sortDirection: null,
    accessor: "description",
    name: t(translationConstants.DESCRIPTION),
    selector: (row) =>
      direction === Directions.rtl && row.arabicDescription
        ? row.arabicDescription
        : row.description,
    // minWidth: TableColumnStyle.COLUMN_WIDTH_180,
  },
  {
    id: "actions",
    name: t(translationConstants.Actions),
    center: true,
    cell: (row) => (
      <>
        <TableViewIcon
          direction={direction}
          onClick={() => {
            getRowData(row);
            setModalMode(modeConstants.VIEW_MODE);
          }}
        />
        <TableEditIcon
          direction={direction}
          onClick={() => {
            getRowData(row);
            setModalMode(modeConstants.EDIT_MODE);
          }}
        />
        <TableDeleteIcon
          direction={direction}
          onClick={() => {
            onDelete(row);
          }}
        />
      </>
    ),
  },
];

export const genderAllowed = (t) => [
  {
    label: t(translationConstants.male),
    value: genderEnum.MALE,
  },
  {
    label: t(translationConstants.female),
    value: genderEnum.FEMALE,
  },
  {
    label: t(translationConstants.MIXED),
    value: genderEnum.MIXED,
  },
];

export const getTranslatedGenders = (t, selectedGenders) => {
  const allGenders = genderAllowed(t);

  return allGenders
    .filter((gender) => selectedGenders.includes(gender.value)) // Filter based on selected values
    .map((gender) => gender.label) // Extract the labels
    .join(", "); // Join them by comma
};

export const sportType = (t) => [
  {
    label: t(translationConstants.SAILING),
    value: sportConstants.SAILING,
  },
  {
    label: t(translationConstants.KITESURFING),
    value: sportConstants.KITESURFING,
  },
  {
    label: t(translationConstants.WINGFOILING),
    value: sportConstants.WINGFOILING,
  },
  {
    label: t(translationConstants.WINDSURFING),
    value: sportConstants.WINDSURFING,
  },
];

export const getSportTranslation = (t, sportId) => {
  const sportKey = Object.keys(sportConstants).find(
    (key) => sportConstants[key] === sportId
  );
  return sportKey ? t(translationConstants[sportKey]) : null; // Return null or a default value if not found
};

export const boatType = (t) => [
  {
    label: t(translationConstants.DINGHY),
    value: boatTypeEnum.DINGHY,
  },
  {
    label: t(translationConstants.KEELBOAT),
    value: boatTypeEnum.KEELBOAT,
  },
  {
    label: t(translationConstants.MULTI_HULL),
    value: boatTypeEnum.MULTI_HULL,
  },
  {
    label: t(translationConstants.YACHT),
    value: boatTypeEnum.YACHT,
  },
  {
    label: t(translationConstants.FORMULA_KITE),
    value: boatTypeEnum.FORMULA_KITE,
  },
  {
    label: t(translationConstants.KITE_BOARDER),
    value: boatTypeEnum.KITE_BOARDER,
  },
  {
    label: t(translationConstants.IQFOIL),
    value: boatTypeEnum.IQFOIL,
  },
  {
    label: t(translationConstants.WIND_SURFER),
    value: boatTypeEnum.WIND_SURFER,
  },
  {
    label: t(translationConstants.FORMULA_WING),
    value: boatTypeEnum.FORMULA_WING,
  },
  {
    label: t(translationConstants.WING_FOILER),
    value: boatTypeEnum.WING_FOILER,
  },
];

export const getBoatTypeTranslation = (t, boatTypeId) => {
  const boatTypeKey = Object.keys(boatTypeEnum).find(
    (key) => boatTypeEnum[key] === boatTypeId
  );
  return boatTypeKey ? t(translationConstants[boatTypeKey]) : null; // Return null or a default value if not found
};
